<template>

    <div class="form-check mb-3">
        <input type="checkbox" 
               :id="id" 
               ref="input" 
               v-bind="$attrs" 
               class="form-check-input" 
               :class="{ 'is-invalid': error }" 
               :checked="checked" 
               @change="$emit('change', $event.target.checked)" />

        <label v-if="label" class="form-check-label" :for="id">
            {{ translatedLabel }}
            <span v-if="help">
                <i class="bi bi-question-circle" :title="help"></i>
            </span>
        </label>

        <div v-if="error" class="invalid-feedback">{{ error }}</div>

    </div>

</template>

<script>
    export default {
        inheritAttrs: false,
        model: {
            prop: 'checked',
            event: 'change'
        },
        props: {
            id: {
                type: String,
                default() {
                    return `checkbox-input-${this._uid}`
                },
            },
            checked: [Boolean, Number],
            label: String,
            error: String,
            help: String,

        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
        methods: {
            focus() {
                this.$refs.input.focus()
            },
        },
    }
</script>